import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 📄 Ventas por Sucursales
 *
 * Reporte:
 * Ventas
 *
 * Filtros requeridos:
 * - Fecha Desde
 * - Fecha Hasta
 *
 * Backend esperado:
 *
 * dateFrom
 * dateTo
 */
export const salesByBranchReportFilters: UniversalFilterConfig[] = [
    {
        name: "dateFrom",
        label: "Fecha Desde",
        type: "date",
        iconKey: "calendar",
    },
    {
        name: "dateTo",
        label: "Fecha Hasta",
        type: "date",
        iconKey: "calendar",
    },
];